import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { destinationForUser, userHasRole } from "../lib/roleRouting";

export default function RoleRoute({ allowedRoles, children }) {
    const { user, activeClubId } = useAuth();
    if (user === null) return <div className="min-h-screen flex items-center justify-center bg-slate-50"><Loader2 className="w-8 h-8 animate-spin text-orange-500" /></div>;
    if (!user) return <Navigate to="/login" replace />;
    if (!userHasRole(user, allowedRoles, activeClubId)) {
        return <Navigate to={destinationForUser(user, activeClubId)} replace />;
    }
    return children;
}
